<template>
    <div v-if="message" class="free-shipping-notice">
        <i class="fas fa-truck"></i>
        <span>{{ message }}</span>
    </div>
</template>

<script>
import Currency from '../../helpers/parseCurrency'

// Aviso informativo (painel: Configuracao de pedidos > Frete gratis a partir de).
// Quem cobra ou nao o frete e a regra da transportadora; o valor comparado e o
// mesmo da faixa de valor dela: produtos com cupom e desconto progressivo.
export default {
    name: 'FreeShippingNotice',
    props: {
        minAmount: {
            default: 0
        },
        netAmount: {
            default: 0
        }
    },
    data() {
        return {
            currency: Currency
        }
    },
    computed: {
        message() {
            const min = Number(this.minAmount) || 0
            if (min <= 0) {
                return null
            }
            const missing = Math.round((min - (Number(this.netAmount) || 0)) * 100) / 100
            if (missing > 0) {
                return `Frete grátis a partir de ${this.currency.money(min)} (valor líquido). Adicione mais ${this.currency.money(missing)} em produtos para ganhar.`
            }
            return `Seu pedido atingiu o valor para frete grátis (a partir de ${this.currency.money(min)}).`
        }
    }
}
</script>

<style scoped>
.free-shipping-notice {
    align-items: center;
    background: #f3f8ff;
    border: 1px solid #c6daf2;
    color: #2c4a6e;
    display: flex;
    font-size: 1.4rem;
    gap: .8rem;
    line-height: 1.35;
    margin: 0 0 1.5rem;
    padding: 1.1rem 1.4rem;
}

.free-shipping-notice i {
    color: #3f73b3;
    flex: 0 0 auto;
}
</style>
